const menuItems = {
  items: [
    {
      id: 'navigation',
      title: 'ADMIN',
      type: 'group',
      // icon: 'icon-navigation',
      children: [
        {
          id: 'dashboard',
          title: 'Dashboard',
          type: 'item',
          icon: 'feather icon-home',
          url: '/app/dashboard/analytics',
          breadcrumbs: false
        }, 
        {
          id: 'menu-level-1.2',
          title: 'GLOBAL SETTINGS',
          type: 'collapse',
          icon: 'feather icon-globe',
          children: [ 
            {
              id: 'CompanySettings',
              title: 'Company Settings',
              type: 'item',
              url: '/leave/',
              breadcrumbs: false
            },
            {
              id: 'GeneralCodes',
              title: 'General Codes',
              type: 'item',
              url: '/leave/',
              breadcrumbs: false
            },
            {
              id: 'SerialNumbers',
              title: 'Serial Numbers',
              type: 'item',
              url: '/leave/',
              breadcrumbs: false
            }
          ]
        },
        {
          id: 'menu-level-1.3',
          title: 'GENERAL SETTINGS',
          type: 'collapse',
          icon: 'feather icon-settings',
          children: [
            {
              id: 'GeneralCodes',
              title: 'General Codes',
              type: 'item',
              url: '/customers/',
              breadcrumbs: false
            },
            {
              id: 'Products',
              title: 'Products',
              type: 'item',
              url: '/customers/',
              breadcrumbs: false
            },
            {
              id: 'menu-level-1.3.1',
              title: 'Annuity Setup',
              type: 'collapse',
              children: [
                {
                  id: 'AnnuityRates',
                  title: 'Annuity Rates',
                  type: 'item',
                  url: '/leave/',
                  breadcrumbs: false
                },
                {
                  id: 'AnnuityPeriods',
                  title: 'Annuity Periods',
                  type: 'item',
                  url: '/leave/',
                  breadcrumbs: false
                }
              ]
            },
          ]
        }
      ]
    },
    {
      id: 'maintenance-mainmenu',
      title: 'MAINTENANCE',
      type: 'group',
      icon: 'icon-support',
      children: [ 
        {
          id: 'customers-menu',
          title: 'CUSTOMERS',
          type: 'item',
          icon: 'feather icon-briefcase' ,
          url: '/customers/customer-list',
          breadcrumbs: false
        },     
        {
          id: 'active-schemes-menu',
          title: 'ACTIVE SCHEMES',
          type: 'item',
           icon: 'feather icon-book',
           url: '/schemes/schemes-list', 
           breadcrumbs: false
        },
        {
          id: 'old-schemes-menu',
          title: 'OLD SCHEMES',
          type: 'item',
          // icon: 'feather icon-camera-off', 
           icon: 'feather icon-eye-off' , 
          url: '/schemes/schemes-list-old', 
          breadcrumbs: false
        },  
      ]
    },  
    {
      id: 'processes',
      title: 'PROCESSES',
      type: 'group',
      icon: 'icon-support',
      children: [ 
        {
          id: 'Contributions',
          title: 'Contributions',
          type: 'item',
          icon: 'feather icon-activity',
          url: '/leave/',
          breadcrumbs: false
        }, 
        {
          id: 'Interests',
          title: 'Interests',
          type: 'item',
          icon: 'feather icon-bar-chart',
          url: '/leave/',
          breadcrumbs: false
        }, 
        {
          id: 'Charges',
          title: 'Charges/Levies',
          type: 'item',
          icon: 'feather icon-plus-circle',
          url: '/leave/',
          breadcrumbs: false
        }, 
      
      ]
    },  
    {
      id: 'helps',
      title: 'HELPS',
      type: 'group',
      icon: 'icon-support',
      children: [ 
        {
          id: 'help-desk',
          title: 'Issues Log',
          type: 'item',
          icon: 'feather icon-phone-outgoing', 
          url: '/leave/',
          breadcrumbs: false
        }, 
        {
          id: 'Guides',
          title: 'System Guides',
          type: 'item',
          icon: 'feather icon-layers', 
          url: '/leave/',
          breadcrumbs: false
        }
      ]
    }
  ]
};

export default menuItems;
